import React, { FC, useRef } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppFieldBox } from 'components/appComponents';
import { DateBox, Validator } from 'devextreme-react';

type TimeTaskProps = {
  value: string | Date | undefined;
  readOnly: boolean;
  onChange: (e: string | Date) => void;
};

const TimeTask: FC<TimeTaskProps> = ({ value, readOnly, onChange }) => {
  let timeRef = useRef<DateBox | null>(null);

  return (
    <AppFieldBox label="Время" labelTop>
      <DateBox
        stylingMode="underlined"
        //type="time"
        readOnly={readOnly}
        ref={timeRef}
        id="time_field"
        value={value}
        //@ts-ignore
        onValueChange={onChange}
        dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
        placeholder="00:00"
        useMaskBehavior={true}
        type="time"
        displayFormat="HH:mm"
        onFocusIn={() => setTimeout(() => timeRef.current?.instance.open(), 100)}
      >
        <Validator>
          <RequiredRule message="Заполните поле время" />
        </Validator>
      </DateBox>
    </AppFieldBox>
  );
};

export default TimeTask;
